import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 29 27",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 29 27\" id=\"icon-plus\"><g transform=\"translate(1.247)\" fill=\"none\" fill-rule=\"evenodd\"><circle stroke=\"#F15A30\" stroke-width=\".56\" fill=\"#F15A30\" cx=\"13.078\" cy=\"13.578\" r=\"13.078\" /><path stroke=\"#FFF\" stroke-width=\"1.4\" fill=\"#1A452D\" stroke-linecap=\"round\" d=\"M8.038 13.578h10.08\" /><path stroke=\"#FFF\" stroke-width=\"1.4\" stroke-linecap=\"round\" d=\"M13.078 8.538v10.08\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol